// extracted by mini-css-extract-plugin
export default {"CenterContent":"CenterContent_CenterContent__GzJEp"};